import Axios from 'axios';
import SingleAction from 'chameleon/ui-stack/ui/assessments/actions/single-action';
import log from 'chameleon/ui-stack/utilities/log';
import { withRouter } from 'react-router';
import { AccessibilityWrapper, notify } from 'legacy-packages/ft-cb';
import { toast } from 'chameleon/ui-stack/ui/toast';
import { FlyoutSecondMenu } from 'chameleon/ui-stack/ui/assessments/actions/FlyoutSecondMenu';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import React from 'react';

const ShowHideResultsForStudentsAction = ({
  assignment,
  fetchAssessmentData,
  disabled,
}) => {
  const { score_display } = assignment;

  function toggleScoreDisplayForAssignment(scoreDisplay) {
    const data = { score_display: scoreDisplay };

    Axios.put(
      `${FYM_BACKEND_URL}/assessments/api/assignments/${assignment.id}/`,
      data,
    )
      .then((response) => {
        if (response.status >= 400) {
          notify.error(
            `${response.data.message} Please, contact the support team.`,
            { timeout: 5 },
          );
        } else {
          toast('Successfully updated assignment!', { timeout: 5 });
        }
      })
      .then(() => {
        fetchAssessmentData();
      })
      .catch((e) => {
        log(e);
      });
  }
  return (
    <FlyoutSecondMenu
      isNarrow
      className="update-labels"
      position="right-end"
      trigger={(buttonProps, isOpen, reference) => (
        <AccessibilityWrapper>
          <SingleAction
            iconName="show"
            ref={reference}
            {...buttonProps}
            disabled={disabled}
          >
            Show/Hide Results for Students{' '}
            <Icon id="chevron_right" className="ml-0.8 h-4 self-center" />
          </SingleAction>
        </AccessibilityWrapper>
      )}
    >
      <div role="menu">
        <ul role="group" className="p-0 m-0 pl-6 pt-1 pr-6">
          <li
            role="menuitem"
            className="list-none py-4 m-0 flex justify-between"
            onClick={() => toggleScoreDisplayForAssignment('full')}
          >
            <div>Full Report</div>
            {score_display === 'full' && (
              <div>
                <Icon id="mark_complete" />
              </div>
            )}
          </li>
          <li
            role="menuitem"
            className="list-none py-4 m-0 flex justify-between"
            onClick={() => toggleScoreDisplayForAssignment('partial')}
          >
            <div>Partial Report</div>
            {score_display === 'partial' && (
              <div>
                <Icon id="mark_complete" />
              </div>
            )}
          </li>
          <li
            role="menuitem"
            className="list-none py-4 m-0 flex justify-between"
            onClick={() => toggleScoreDisplayForAssignment('no')}
          >
            <div>No</div>
            {score_display === 'no' && (
              <div>
                <Icon id="mark_complete" />
              </div>
            )}
          </li>
        </ul>
      </div>
    </FlyoutSecondMenu>
  );
};

export default withRouter(ShowHideResultsForStudentsAction);
